import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

interface ReportErrorCardProps {
  error: Error;
}

export function ReportErrorCard({ error }: ReportErrorCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Failed to load report</CardTitle>
        <CardDescription>
          {error.message || "An unexpected error occurred."}
        </CardDescription>
      </CardHeader>
    </Card>
  );
}
